import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Illustration from '../Illustration/Illustration';
import MostSearchedCourses from '../CourseSections/MostSearchedCourses';
import ExploringSkills from '../CourseSections/ExploringSkills';
import PrevSearchedCourse from '../CourseSections/PrevSearchedCourse';
import LanguageRelevantCourses from '../CourseSections/LanguageRelevantCourses';
import ContactFormWithMap from '../Footer/ContactFormWithMap';
import RecommendedCourses from '../CourseSections/RecommendedCourses';
import RecentlyCompletedCourses from '../CourseSections/RecentlyCompleted';
import AboutCertificate from '../DashboardCertificate/AboutCertificate';
import InfiniteScroll from '../Illustration/InfiniteScroll';
import NotificationPopup from './NotificationPopup';
import CourseReviewTestimonials from '../ReviewTestimonials/CourseReviewTestimonials';
import JobSuccessTestimonials from '../ReviewTestimonials/JobSuccessTestimonials';
import AIInterviewPopup from './AIInterviewPopup';
import ProjectCourse from '../CourseSections/ProjectCourse';
import SubCategoryCourses from '../CourseSections/SubCategoryCourses';
import FestivaSalelBanner from '../SaleBanner/FestivalSaleBanner';

const MainDashboard = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    setShowPopup(true);
  }, []);

function getOffsetDateTime() {
  const date = new Date();
  const offsetMinutes = date.getTimezoneOffset(); // e.g., -330 for IST
  const absOffsetMinutes = Math.abs(offsetMinutes);
  const sign = offsetMinutes <= 0 ? '+' : '-';
  const pad = (n) => String(n).padStart(2, '0');

  const offsetHours = pad(Math.floor(absOffsetMinutes / 60));
  const offsetMins = pad(absOffsetMinutes % 60);
  const offsetStr = `${sign}${offsetHours}:${offsetMins}`;

  const localISO = new Date(date.getTime() - offsetMinutes * 60000)
    .toISOString()
    .split('.')[0];

  return `${localISO}${offsetStr}`;
}

const transactionDate = getOffsetDateTime();
console.log(transactionDate);


  return (
    <>
    {/* <FestivaSalelBanner/> */}
      <Helmet>
        <title>Online IT Courses & Programming Training | SkillzVerse</title>
        <meta
          name="description"
          content="Explore online IT courses at SkillzVerse with expert-led training in programming, full stack development, AI, cloud computing, and practical career-focused learning."
        />

         <meta
    name="keywords"
    content="online IT courses,Online Programming Courses,IT Training Platform,Full Stack Development Courses,Java Programming Course,Python Programming Course,Web Development Courses,AI & Machine Learning Courses,Software Development Training,Career Skill Development,Online Learning Platform,Expert-Led Courses,Skill Development Courses"
  />

    <link
    rel="canonical"
    href="https://skillzverse.com/"
  />
        <meta property="og:title" content="SkillzVerse | Your Personalized Dashboard" />
        <meta
          property="og:description"
          content="Track progress, explore top courses, and get job-ready skills on your SkillzVerse dashboard."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://skillzverse.com/dashboard" />
        <meta property="og:image" content="https://skillzverse.com/assets/dashboard-cover.png" />
        <meta name="twitter:title" content="SkillzVerse Dashboard" />
        <meta
          name="twitter:description"
          content="Access your SkillzVerse dashboard to continue your learning journey with top-rated tech courses."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "SkillzVerse Dashboard",
            "url": "https://skillzverse.com",
            "description":
              "SkillzVerse personalized dashboard enables learners to track course progress, access certifications, explore career-boosting resources, and engage in project-based learning.",
            "applicationCategory": "EducationalApplication",
            "operatingSystem": "All",
            "publisher": {
              "@type": "Organization",
              "name": "SkillzVerse",
              "url": "https://skillzverse.com"
            }
          })}
        </script>
      </Helmet>

      {showPopup && <AIInterviewPopup onClose={() => setShowPopup(false)} />}
      <Illustration />
      <InfiniteScroll />
      <RecommendedCourses />
      <ExploringSkills />
      <SubCategoryCourses />
      <LanguageRelevantCourses />
      <ProjectCourse />
      <MostSearchedCourses />
      <PrevSearchedCourse />
      <RecentlyCompletedCourses />
      <AboutCertificate />
      <CourseReviewTestimonials />
      <JobSuccessTestimonials />
      <ContactFormWithMap />
      <NotificationPopup />
    </>
  );
};

export default MainDashboard;
